export enum Roles {
    Outcast = 'Outcast',
    Stranger = 'Stranger',
    Citizen = 'Citizen',
    Peasant = 'Peasant',
    Secretary = 'Secretary',
    Treasurer = 'Treasurer',
    Lord = 'Lord',
};

export enum Paths {
    Main =  '/',
    Login=  '/login',
    Register= '/register',
    Join=  '/join',
    Members =  '/members',
    Joined =  '/joined',
    Ban =  '/ban',
    Treasury = '/treasury'
}
